/* eslint-disable react-refresh/only-export-components */

import type { Pagination } from '@aigc/types';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Typography } from 'antd';
import { parsePaginationSearch } from '../../../features/common/pagination-search';
import { ScriptHistory } from '../../../features/statistics/components/script-history';

export const Route = createFileRoute(
  '/_creator-center/admin/statistics/script',
)({
  validateSearch: parsePaginationSearch,
  component: Statistics,
});

function Statistics() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const handlePaginationChange = (pagination: Pagination) => {
    navigate({
      replace: true,
      search: {
        page: pagination.page ?? 1,
        pageSize: pagination.size ?? 10,
      },
    });
  };

  return (
    <div className="h-full overflow-auto bg-white p-4">
      <div className="mb-4 flex flex-wrap items-center">
        <Typography.Title level={4} style={{ margin: 0 }}>
          历史脚本
        </Typography.Title>
      </div>
      <ScriptHistory
        defaultPagination={{ page: search?.page, size: search?.pageSize }}
        onPaginationChange={handlePaginationChange}
        admin
      ></ScriptHistory>
    </div>
  );
}
